import { WHITE_LIST_PERSISTED_STATE_KEYS, loadState } from "@axvdex/state/persist";

export const hasPermitStored = (walletInfo: { pubKey: string }) => {
  return !!loadState(WHITE_LIST_PERSISTED_STATE_KEYS.permits)["cosmos_" + walletInfo.pubKey];
};
